import { PageLoading } from "@ilabel/ui";

import "./operation-console-loading.css";

export function OperationConsoleStartupLoading() {
  return (
    <PageLoading
      fullscreen
      className="operation-console-startup"
      ariaLabel="操作台加载中"
      indicator="bar"
      indicatorPlacement="after"
      icon={
        <img
          className="operation-console-startup-logo"
          src="/logo.svg"
          alt=""
          aria-hidden="true"
        />
      }
      title="正在打开操作台"
    />
  );
}
